import defaultConfig from './default';
import localConfig from './local';
import developmentConfig from './development';
import productionConfig from './production';

const config = () => {
  const ENV = process.env.REACT_APP_ENV;
  const VERSION = process.env.REACT_APP_VERSION;
  const DATE = process.env.REACT_APP_DATE;

  const getEnv = () => {
    return ENV;
  };

  const getVersion = () => {
    return VERSION;
  };

  const getDate = () => {
    return DATE;
  };

  const isLocal = () => {
    return ENV === 'LOCAL';
  };
  const isDev = () => {
    return ENV === 'DEVELOPMENT';
  };
  const isProd = () => {
    return ENV === 'PRODUCTION';
  };

  let environment = {};
  if (isLocal()) {
    environment = { ...defaultConfig, ...localConfig };
  } else if (isDev()) {
    environment = { ...defaultConfig, ...developmentConfig };
  } else if (isProd()) {
    environment = { ...defaultConfig, ...productionConfig };
  }

  environment.isLocal = isLocal();
  environment.isDev = isDev();
  environment.isProd = isProd();
  environment.env = getEnv();
  environment.version = getVersion();
  environment.date = getDate();

  return environment;
};

export default config();
